import gql from 'graphql-tag';

export const START_EXPERIMENT_MUTATION = gql`
  mutation StartExperimentMutation($experimentId: Int!) {
    startExperiment(experimentId: $experimentId) {
      experiment {
        status
      }
      errors
    }
  }
`;
